import { createContext, useContext } from 'react';

/**
 * FormField -> Input/Select arasindaki baglanti. Ayri dosyada, cunku bir modul
 * hem bilesen hem baska sey ihrac ettiginde Vite'in hizli yenilemesi (HMR)
 * bilesen sinirini kaybediyor (eslint: react-refresh/only-export-components).
 */
export type FormFieldContextValue = {
  /** Kontrolun id'si — <label for> ile eslesir. */
  controlId: string;
  /** Hata/ipucu metinlerinin id listesi (aria-describedby). */
  describedBy: string | undefined;
  invalid: boolean;
};

export const FormFieldContext = createContext<FormFieldContextValue | null>(null);

export const useFormFieldContext = (): FormFieldContextValue | null =>
  useContext(FormFieldContext);
